import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import { useSubscribeMutation } from '../../slices/students/studentsApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const TeacherPlanSubscribe = () => {

    const dispatch = useDispatch();

    const { id } = useParams();

    const [myplans, setMyplans] = useState([]);

    const [enroll, setEnroll] = useState(true);

    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplanQuery(id);

    const [subscribe, { isLoading: loadingSubscribe }] = useSubscribeMutation();

    const { studentInfo } = useSelector((state) => state.authStudent);
    


    useEffect(() => {
        if (studentInfo) {
            setMyplans([...studentInfo?.plan, id]);
        }
      }, [studentInfo?.plan]);

    useEffect(() => {
        studentInfo?.plan.map((pla) => {
            if (pla === id) {
                setEnroll(false)
            }
        });
    }, [myplans]);



    const subscribeHandler = async (e) => {
        e.preventDefault()
        try {
            const res = await subscribe({ plans: myplans }).unwrap();
            dispatch(setStudentCredentials({ ...res }));
            toast.success('Subscribed Successfully');
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    }


    return (
        <div className="bg-default2">
            <nav id="navbar-main" className="navbar navbar-horizontal navbar-transparent navbar-main navbar-expand-lg navbar-light">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-collapse navbar-custom-collapse collapse" id="navbar-collapse">
                        <div className="navbar-collapse-header">
                        <div className="row">
                            <div className="col-6 collapse-close">
                            <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                                <span></span>
                                <span></span>
                            </button>
                            </div>
                        </div>
                        </div>
                        <ul className="navbar-nav ">
                        <li className="nav-item">
                            <a href="../../pages/dashboards/dashboard.html" className="nav-link">
                            <span className=" logP">ASK TO LEARN</span>
                            </a>
                        </li>                    
                        </ul>
                        <hr className="d-lg-none" />
                    </div>
                </div>
            </nav> 
            <div className="main-content" >
            <div className="container-fluid mt--5 loginResponsive">
                    <div className="header  py-5 py-lg-6 pt-lg-7">
                    </div> <br /><br />
                        <div className="container mt--10 pb-5 containerP">
                            <div className="row bg-gradient-defaultt titleContainerP">

                            <div className=" offset-lg-2 col-lg-4 text-center"><br /><br />
                                <div className={`card card-pricing bg-gradient-primary shadow-lg rounded border-0 text-center mb-4` }>
                                    <div className="card-header bg-transparent">
                                        <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
                                    </div>
                                    <div className="card-body px-lg-5">
                                        <div className="display-4 text-white">$20</div>
                                        <span className="text-white">monthly</span>
                                        <ul className="list-unstyled my-4">
                                            <li>
                                                <div className="d-flex align-items-center">
                                                <div>
                                                    <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                    <i className="fas fa-check"></i>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span className="pl-1 text-white">You can ask up to 35 monthly questions </span>
                                                </div>
                                                </div>
                                            </li><br />
                                            <li>
                                                <div className="d-flex align-items-center">
                                                <div>
                                                    <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                    <i className="fas fa-check"></i>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span className="pl-2 text-white">Each Question can <br /> &nbsp; &nbsp; last up to 5 minutes</span>
                                                </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-footer bg-transparent card-footer2">
                                    </div>
                                </div>    
                            </div>


                            <div className="  col-lg-4 text-center"><br /><br />
                                <div className="card bg-gradient-primary">
                                <div className="card-body"><br /><br /><br />
                                <div className="row justify-content-between align-items-center">
                                    <div className="col">
                                    <img src="../assets/img/icons/cards/mastercard.png" alt="Image placeholder" />
                                    </div>
                                    <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                        <small className="text-white font-weight-bold mr-3">Make default</small>
                                        <div>
                                        <label className="custom-toggle  custom-toggle-white">
                                            <input type="checkbox" checked="" />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <Form onSubmit={subscribeHandler}>
                                    <div className="form-group">
                                        <div className="input-group input-group-alternative mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="ni ni-single-02"></i></span>
                                        </div>
                                        <input className="form-control" placeholder="Name on card" type="text" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group input-group-alternative mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="ni ni-credit-card"></i></span>
                                        </div>
                                        <input className="form-control" placeholder="Card number" type="text" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                        <div className="form-group">
                                            <div className="input-group input-group-alternative mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><i className="ni ni-calendar-grid-58"></i></span>
                                            </div>
                                            <input className="form-control" placeholder="MM/YY" type="text" />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-6">
                                        <div className="form-group">
                                            <div className="input-group input-group-alternative">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><i className="ni ni-lock-circle-open"></i></span>
                                            </div>
                                            <input className="form-control" placeholder="CCV" type="text" />
                                            </div>
                                        </div>
                                        </div>
                                    </div><br />
                                      { enroll ? 
                                        <Button type="submit" className="btn btn-block btn-info bg-gradient-info">Subscribe</Button>
                                        : <p className='text-white display-6'>You are Suscribed to this plan</p>
                                        }
                                    </Form>
                                    <br /><br />
                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>            
        </div>
    )
}

export default TeacherPlanSubscribe
